import { Badge } from '@/components/ui/badge';
import type { ProvisioningTier } from '@/types/provisioning';

type BadgeVariant = 'active' | 'degraded' | 'failed' | 'idle';

const TIER_STYLES: Record<ProvisioningTier, { label: string; variant: BadgeVariant }> = {
  SAFE: { label: 'Safe', variant: 'active' },
  DEPLOY: { label: 'Deploy', variant: 'degraded' },
  DESTRUCTIVE: { label: 'Destructive', variant: 'failed' },
};

export function TierBadge({
  tier,
  className,
}: {
  tier: ProvisioningTier;
  className?: string;
}): JSX.Element {
  const style = TIER_STYLES[tier] ?? { label: tier, variant: 'idle' as const };

  return (
    <Badge variant={style.variant} className={className}>
      {style.label}
    </Badge>
  );
}
